import React from 'react'
import './AddGuestsPost.css'

function AddGuestsPost(props) {
    return (
        <div className="addguests-bodycontainer">
            <div className="addguests-body-components">
                <div className="addguests-component2">
                    <img src="https://firebasestorage.googleapis.com/v0/b/surge-party.appspot.com/o/images%2Ficon.jpg?alt=media&token=3daebdb0-d4c8-4f34-8f6a-fe33928292de" className="addguests-image" />
                    <div className="addguests-text">
                        <h4 className="addguests-owner">{props.owner}</h4>
                        <h4 className="addguests-id">{props.id}</h4>
                    </div>
                </div>
                <button className="addguests-add-button">Add</button>
            </div>
        </div>
    )
}

export default AddGuestsPost